import React, { useCallback, useRef } from 'react';
import './PlaybackBar.css';

function fmt(secs, fallback = '0:00') {
  if (!isFinite(secs) || secs < 0) return fallback;
  const m = Math.floor(secs / 60);
  const s = Math.floor(secs % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export default function PlaybackBar({ playing, currentTime, duration, onToggle, onSeek }) {
  const scrubbing = useRef(false);

  const handleScrub = useCallback((e) => {
    if (!duration) return;
    const t = (e.target.value / 1000) * duration;
    onSeek(t);
  }, [duration, onSeek]);

  const handleRewind = useCallback(() => {
    onSeek(0);
  }, [onSeek]);

  const progress = duration > 0 ? (currentTime / duration) * 1000 : 0;

  return (
    <div className="playback-bar">
      <button
        className="playback-bar__btn"
        onClick={handleRewind}
        title="Rewind to start"
        aria-label="Rewind"
        disabled={!duration}
      >
        ⏮
      </button>

      <button
        className={`playback-bar__btn playback-bar__btn--play${playing ? ' playing' : ''}`}
        onClick={onToggle}
        title={playing ? 'Pause' : 'Play'}
        aria-label={playing ? 'Pause' : 'Play'}
        disabled={!duration}
      >
        {playing ? '⏸' : '▶'}
      </button>

      <span className="playback-bar__time">{fmt(currentTime)}</span>

      <input
        className="playback-bar__scrubber"
        type="range"
        min={0}
        max={1000}
        step={1}
        value={Math.round(progress)}
        onChange={handleScrub}
        onMouseDown={() => { scrubbing.current = true; }}
        onMouseUp={() => { scrubbing.current = false; }}
        disabled={!duration}
        aria-label="Seek"
      />

      <span className="playback-bar__time playback-bar__time--total">{fmt(duration, '—:—')}</span>
    </div>
  );
}
